import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {ensureNotObject, keyify} from "../common";
import * as common from "../styles/common.module.scss";

function mapFieldNames(fieldName: string): string {
    switch(fieldName) {
        case "earlyTerminationCount":
            return "Early Terminations";
        case "monthToMonthMoveOutCount":
            return "MTM Move Outs";
        default:
            return "-----UNMAPPED NAME-----";
    }
}


export function RenderUpsertOpMetricValues(props: RendererProps): ReactElement {
    const fieldName = props.variables["fieldName"];
    const values = props.variables["values"];
    const monthIndexes = props.variables["monthIndexes"];

    if(!fieldName || !Array.isArray(values) || !Array.isArray(monthIndexes)) {
        return <></>;
    }

    const minLen = Math.min(values.length, monthIndexes.length);
    if(minLen === 0) {
        return <div>Unknown Change</div>;
    }


    const items: ReactElement[] = [];
    for(let i = 0; i < minLen; i++) {
        const value = values[i];
        let month = monthIndexes[i];

        if(typeof month === "number") {
            month++;
        }

        if(value && month) {
            items.push(
                <li key={keyify(month)}>
                    Month {ensureNotObject(month)}: {ensureNotObject(value)}
                </li>
            );
        }
    }

    return <div>
        <div className={common.textSubHeader}>{mapFieldNames(fieldName)}</div>
        {items.length > 0 &&
            <ul>
                {items}
            </ul>
        }
    </div>;
}